<template>
  <section class="brands-strip">
    <div class="brands-strip__container">
      <ul class="brands-strip__list">
        <li
          v-for="partner in partners"
          :key="partner.name"
          class="brands-strip__item"
        >
          <a
            class="brands-strip__link"
            :href="partner.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              :src="$getFileSource(partner.imageSrc)"
              :alt="partner.name"
            />
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { partners } from "../../../data/brandsPartners.json";

export default {
  data() {
    return {
      partners,
    };
  },
};
</script>

<style scoped>
.brands-strip {
  position: relative;
  background: #000;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  width: 100vw;
  padding: 25px 0;
  overflow: hidden;
}

.brands-strip::before,
.brands-strip::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.18),
    rgba(255, 255, 255, 0)
  );
}

.brands-strip::before {
  top: 0;
}

.brands-strip::after {
  bottom: 0;
}

.brands-strip__container {
  width: min(1120px, 90%);
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.brands-strip__list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  align-items: center;
  justify-items: center;
  gap: 40px;
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
}

.brands-strip__item img {
  max-height: 100%;
  max-width: 160px;
  object-fit: contain;
  filter: brightness(0.9) contrast(1.05);
}

@media (max-width: 767.98px) {
  .brands-strip {
    padding: 32px 0;
  }

  .brands-strip__list {
    gap: 24px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .brands-strip__item img {
    max-height: 64px;
  }
}
</style>
